// angular
import { isPlatformServer } from '@angular/common';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import {
  inject,
  makeStateKey,
  PLATFORM_ID,
  REQUEST,
  StateKey,
  TransferState,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
// services
import { StorageService } from '@app/shared/services/storage.service';
import { HandleErrorService } from '@app/shared/services/handle-error.service';
// env
import { environment } from '@environments/environment';

export const BaseInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const storageService = inject(StorageService);
  const handleErrorService = inject(HandleErrorService);
  const translateService = inject(TranslateService);
  const platformId = inject(PLATFORM_ID);
  const transferState = inject(TransferState);
  // const serverRequests = inject(REQUEST);

  let copyReq = req.clone();
  let url = req.url;

  if (!req.url.startsWith('.')) {
    const prefixReq: 'main' | 'um' | 'socket' | 'messenger' = url.split(
      '/'
    )[0] as 'main' | 'um' | 'socket' | 'messenger';
    const serverUrl = environment.baseUrl[prefixReq];
    const config = {
      url: `${serverUrl}${url.replace(prefixReq, '')}`,
      setHeaders: {
        version: `${environment.apiVersion}`,
        'ngrok-skip-browser-warning': 'true',
        'x-custom-lang': storageService.getLang(),
      },
    }
    copyReq = req.clone(config);
    if  (prefixReq === 'um') {
      copyReq = req.clone({
        ...config,
        setHeaders: {
          ...config.setHeaders,
          client: 'wejoiner'
        }
      })
    }
  }

  const key: StateKey<string> = makeStateKey<string>(req.url);

  if (isPlatformServer(platformId) && !req.url.includes('custom-url')) {
    return next(copyReq).pipe(
      // debounceTime(300), // Wait 300ms before making the request
      tap(event => {
        transferState.set(key, (event as HttpResponse<any>).body);
      }),
      catchError((err: any) => {
        if (err.error?.statusCode === 401) {
          storageService.removeToken();
          return throwError(() => err);
        }
        if (err.error?.statusCode === 404) {
          return throwError(() => err);
        }
        // error handling
        handleErrorService.handleError(err);
        return throwError(() => err);
      })
    );
  } else {
    const storedResponse = transferState.get<any>(key, null);
    if (storedResponse) {
      const response = new HttpResponse({ body: storedResponse, status: 200 });
      transferState.remove(key);
      return of(response);
    } else {
      return next(copyReq).pipe(
        catchError((err: any) => {
          if (err.error?.statusCode === 401) {
            storageService.removeToken();
            return throwError(() => err);
          }
          if (err.error?.statusCode === 404) {
            return throwError(() => err);
          }
          // error handling
          handleErrorService.handleError(err);
          return throwError(() => err);
        })
      );
    }
  }
};
